import { t } from '@base/utils/helpers';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from '../styles/pageNotFound.module.scss';

export default function PageNotFound() {
  const history = useHistory();
  return (
    <div>
      <h2 className={styles.title}>
        {t('page_not_found_arg', history.location.pathname)}
      </h2>
    </div>
  );
}
